import {
  styled,
  TableCell,
  Typography,
} from "@mui/material";
import { Endorsement } from "entities/UIModel";
import React from "react";
import { EndorsementStatusType, OrderStatusType } from "utils/data/enum";
import ComboBoxField from "controls/global/combo-box-field";
import { SelectFieldOption } from "controls/global/select-field/SelectInput";
import { colors } from "theme/defaultStyle";
import theme from "theme/default";

type Props = {
  endorsement: Endorsement;
  fullName: string;
  cellCss: string;
  disabled: boolean;
  issuedMode: boolean;
  options: SelectFieldOption[];
  checked: boolean;
  jacketOrderStatusTypeCode?: string;
  handleEndorsementChange: (
    _: React.ChangeEvent<{}>,
    selectedOptionValue: SelectFieldOption
  ) => void;
  handleEndorsementOnBlur: (
    event: React.ChangeEvent<{}>
  ) => void;
  handleEndorsementOnOpen: (event: React.ChangeEvent<{}>)  => void;
};

const StyleCellText = styled(Typography)({
  fontSize: "18px",
  padding: "10px 0px 5px 10px",
  color: colors.grey07,
  "&.disabled": {
    color: colors.grey06,
  },
});

const StyledTableCell = styled(TableCell)({
  minWidth: 340,
  "& .MuiInputBase-root.MuiInput-root.MuiAutocomplete-inputRoot": {
    border: "none",
  },
  "& .MuiInputBase-root.MuiInput-root.MuiAutocomplete-inputRoot.Mui-focused": {
    border: `1px solid ${theme.palette.primary.main}`,
  },
});

export default function EndorsementNameCell({
  endorsement: {
    isSFE,
    endorsementName,
    endorsementID,
    endorsementStatusTypeCode,
    endorsementNumber,
  },
  fullName,
  cellCss,
  disabled,
  issuedMode,
  options,
  jacketOrderStatusTypeCode,
  handleEndorsementChange,
  handleEndorsementOnBlur,
  handleEndorsementOnOpen,
  checked =false,
}: Props) {

  // console.log("options:", options);
  const isCellDisabled: boolean =
    disabled ||
    Boolean(
      endorsementID &&
        endorsementStatusTypeCode !== EndorsementStatusType.Pending &&
        issuedMode
    )
  
  const isJacketIssuedSFEPending =
    jacketOrderStatusTypeCode?.toUpperCase() === OrderStatusType.Issued &&
    isSFE &&
    endorsementStatusTypeCode === EndorsementStatusType.Pending;

  const isCheckboxDisabled: boolean = isJacketIssuedSFEPending
    ? false
    : disabled ||
      Boolean(
        endorsementID &&
          endorsementStatusTypeCode !== EndorsementStatusType.Pending &&
          issuedMode
      ) || !checked;

  const isIssuedOrVoided = endorsementStatusTypeCode === EndorsementStatusType.Issued || 
                   endorsementStatusTypeCode === EndorsementStatusType.Voided;
  
  const displaySuffix = isCellDisabled && isIssuedOrVoided && endorsementNumber 
    ? `(${endorsementNumber})`
    : undefined;

  if (isSFE) {
    const displayName = displaySuffix ? `${endorsementName} ${displaySuffix}` : endorsementName;
    return (
      <TableCell classes={{ sizeSmall: cellCss }} style={{ minWidth: 340 }}>
        <StyleCellText className={isCheckboxDisabled ? "disabled" : ""}>
          {displayName}
        </StyleCellText>
      </TableCell>
    );
  }
  
  return (
    <StyledTableCell classes={{ sizeSmall: cellCss }}>
      <>
        <ComboBoxField
          label=""
          size="small"
          noBorder
          placeholder="Select or Type Endorsement"
          name={fullName}
          defaultValue={endorsementName}
          options={options}
          onChange={handleEndorsementChange}
          onBlur={handleEndorsementOnBlur}
          disabled={isCellDisabled}
          controlTooltipOnMouseEvents = {!(isCellDisabled)} // Disregard tooltip in enabled mode. It is interfering with autocomplete popper
          freeSolo={true}
          displaySuffix={displaySuffix}
          onOpen={handleEndorsementOnOpen}
        />
      </>
    </StyledTableCell>
  );
}
